<!-- 区域数据展板全景 -->
<template>
  <div class="region-panorama-board">
    <div class="region-panorama-board-top">
      <div class="region-panorama-board-top-title">
        <div class="title">{{ title }}</div>
        <div class="left-btn">
          <div class="name" :class="dataBoard == '/panorama' ? 'is-active' : ''" @click="changeRouter('/panorama')">全景
          </div>
          <div class="name" :class="dataBoard == '/teaching' ? 'is-active' : ''" @click="changeRouter('/teaching')">教学
          </div>
        </div>
        <div class="right-btn">
          <div class="name" :class="dataBoard == '/resource' ? 'is-active' : ''" @click="changeRouter('/resource')">资源
          </div>
          <div class="name" :class="dataBoard == '/regionresearch' ? 'is-active' : ''"
            @click="changeRouter('/regionresearch')">教研</div>
        </div>
      </div>
      <div class="region-panorama-board-top-filter">
        <div class="filter-btn" @click="changeFilter('all')" :class="filterSelect == 'all' ? 'is-select' : ''">全部</div>
        <div class="filter-btn" @click="changeFilter('year')" :class="filterSelect == 'year' ? 'is-select' : ''">本学年
        </div>
        <div class="filter-btn" @click="changeFilter('month')" :class="filterSelect == 'month' ? 'is-select' : ''">本月
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'region-panorama-board',
  data() {
    return {
      filterSelect: 'all',
      dataBoard: "/panorama"
    }
  },
  computed: {
    title() {
      let res = '高新区教育局大数据展板'
      if (this.dataBoard == '/resource') {
        res += '  --  资源'
      } else if (this.dataBoard == '/regionresearch') {
        res += '  --  教研'
      }
      return res
    }
  },
  methods: {
    changeRouter(value) {
      if (value == 'teaching') {
        // this.$router.push({
        //     path: value,
        //     query: {
        //       areaTitle: '高新区智能大数据监管平台',
        //       areaCode: '340100'
        //     }
        // })
        window.open('/areaschooldataboard?areaTitle=高新区智能大数据监管平台&areaCode=340100', '_blank')
      } else {
        this.$router.push({
          path: value
        })
      }
      this.dataBoard = value;
    },
    changeFilter(value) {
      this.filterSelect = value;
    }
  },
  mounted() {
    this.dataBoard = this.$route.path
  },
}
</script>
<style lang="scss" scoped>
.region-panorama-board {
  width: 100%;
  height: auto;
  min-height: 100%;
  padding: 0 20px;
  // background-color: rgb(6,17,52);
  background: url('../../../assets/images/databoard/bg5.png');

  .region-panorama-board-top {
    color: #fff;
    height: 126px;
    width: 100%;
    position: relative;
    background-color: rgba(6, 17, 52, 0.8);

    .region-panorama-board-top-title {
      // width: calc(100% - 200px);
      // width: 1690px;
      height: 95px;
      margin: 0 auto;
      background: url('../../../assets/images/sydataboard/头部背景图.png') no-repeat;
      background-size: 100% 100%;
      text-align: center;
      position: relative;

      .title {
        display: inline-block;
        font-size: 30px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #FFFFFF;
        margin-top: 20px;
      }

      .left-btn {
        position: absolute;
        left: 70px;
        display: flex;
        top: 25px;

        .name {
          width: 170px;
          height: 45px;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 40px;
          color: rgba(255, 255, 255, 0.5);
          background: url('../../../assets/images/sydataboard/模块切换.png') no-repeat;
          background-size: 100% 100%;
          margin-right: 20px;
          cursor: pointer;

          &:hover {
            color: #FFFFFF;
          }
        }
      }

      .right-btn {
        position: absolute;
        right: 70px;
        display: flex;
        top: 25px;

        .name {
          width: 170px;
          height: 45px;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 40px;
          color: rgba(255, 255, 255, 0.5);
          background: url('../../../assets/images/sydataboard/模块切换.png') no-repeat;
          background-size: 100% 100%;
          margin-left: 20px;
          cursor: pointer;

          &:hover {
            color: #FFFFFF;
          }
        }
      }

      .is-active {
        color: #FFFFFF !important;
      }
    }

    .region-panorama-board-top-full {
      position: absolute;
      right: 20px;
      bottom: 40px;
      cursor: pointer;

      .full-title {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #2773E6;
        margin-left: 5px;
      }
    }

    .region-panorama-board-top-filter {
      position: absolute;
      left: 20px;
      bottom: 10px;
      display: flex;
      align-items: center;
      background: rgba(31, 51, 141, 0.57);
      border-radius: 4px;

      .filter-btn {
        padding: 9px 15px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #C1ECFF;
        cursor: pointer;
      }

      .is-select {
        background: #2B7FFF;
        border-radius: 4px;
        color: #FFFFFF;
      }
    }
  }
}
</style>